import { ThemePaletteConfiguration } from "../../types/theme";

export const PRIMARY_COLOR_THEME = '#2C3B96' as const;
export const SECONDARY_COLOR_THEME = '#9AECED' as const;
export const TERTIARY_COLOR_THEME = '#E592B5' as const;
export const BACKGROUND_COLOR_THEME = '#FFFFFF' as const;
export const BACKGROUND_COLOR_SECONDARY_THEME = '#F1F1F1' as const;
export const TEXT_PRIMARY_COLOR_THEME = '#0B0F28' as const;
export const TEXT_SECONDARY_COLOR_THEME = '#FFFFFF' as const;
export const TEXT_LABEL_COLOR_THEME = '#8080808C' as const; // TODO: ?
export const SUCCESS_COLOR_THEME = '#34C759' as const;
export const ERROR_COLOR_THEME = '#FF2D55' as const;
export const TEXT_TERTIARY_COLOR_THEME = '#739CE7' as const;
export const APP_THEME_COLORS = [
  PRIMARY_COLOR_THEME,
  SECONDARY_COLOR_THEME,
  TERTIARY_COLOR_THEME,
  BACKGROUND_COLOR_THEME,
  BACKGROUND_COLOR_SECONDARY_THEME,
  TEXT_PRIMARY_COLOR_THEME,
  TEXT_SECONDARY_COLOR_THEME,
  TEXT_LABEL_COLOR_THEME,
  SUCCESS_COLOR_THEME,
  ERROR_COLOR_THEME,
  TEXT_TERTIARY_COLOR_THEME,
] as const;

export const THEME_PALETTE: ThemePaletteConfiguration = {
  primary: PRIMARY_COLOR_THEME,
  secondary: SECONDARY_COLOR_THEME,
  tertiary: TERTIARY_COLOR_THEME,
  background: BACKGROUND_COLOR_THEME,
  backgroundSecondary: BACKGROUND_COLOR_SECONDARY_THEME,
  text: TEXT_PRIMARY_COLOR_THEME,
  textSecondary: TEXT_SECONDARY_COLOR_THEME,
  textLabel: TEXT_LABEL_COLOR_THEME,
  success: SUCCESS_COLOR_THEME,
  error: ERROR_COLOR_THEME,
  textTertiary: TEXT_TERTIARY_COLOR_THEME,
}
